// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "@reach/router";
import PageHeader from "../../../components/PageHeader";
import PageTitle from "../../../components/PageTitle";
import PageBody from "../../../components/PageBody";
import { AuthentifiedUser } from "../../../../api/backend-openapi";
import { useStore } from "effector-react";
import { authentifiedUserStore } from "../../../../state/auth/AuthStore";
import { NboAction } from "../../../types/AuthTypes";
import SurveyForm from "./SurveyForm";

interface SurveyEditProps extends RouteComponentProps {
  surveyId?: string;
}

const SurveyScreen: React.FunctionComponent<SurveyEditProps> = (
  props: SurveyEditProps
) => {
  const { t } = useTranslation();
  const authentifiedUser: AuthentifiedUser | null = useStore(
    authentifiedUserStore
  );
  const canEdit: boolean =
    (authentifiedUser &&
      authentifiedUser.rights &&
      authentifiedUser.rights.nboSurvey &&
      typeof authentifiedUser.rights.nboSurvey.find(
        survey => survey === NboAction.nboUpdate
      ) === "string") ||
    false;
  const canValidate: boolean =
    (authentifiedUser &&
      authentifiedUser.rights &&
      authentifiedUser.rights.nboSurvey &&
      typeof authentifiedUser.rights.nboSurvey.find(
        survey => survey === NboAction.nboValidate
      ) === "string") ||
    false;
  const canDelete: boolean =
    (authentifiedUser &&
      authentifiedUser.rights &&
      authentifiedUser.rights.nboSurvey &&
      typeof authentifiedUser.rights.nboSurvey.find(
        survey => survey === NboAction.nboDelete
      ) === "string") ||
    false;

  const [editMode, setEditMode] = useState<boolean>(false);
  const { surveyId } = props;
  return (
    <>
      <PageHeader>
        <PageTitle
          title={t(editMode ? "edit_survey.title" : "detail_survey.title")}
        />
      </PageHeader>
      <PageBody>
        <SurveyForm
          surveyId={surveyId ? surveyId : ""}
          editMode={editMode}
          setEditMode={setEditMode}
          canEdit={canEdit}
          canValidate={canValidate}
          canDelete={canDelete}
        />
      </PageBody>
    </>
  );
};

export default SurveyScreen;
